export const PATH = {
  HOME: '/',
  AUTHENTICATION: {
    LOGIN: '/login'
  },
  ANALYTICS: {
    DASHBOARD: '/scans'
  },
  EXPERIENCES: {
    LIST: '/experiences',
    EDIT: '/experience/:id',
    CREATE: '/experience'
  },
  MULTILANGUAGE_EXPERIENCES: {
    LIST: '/multilanguage-experiences',
    EDIT: '/multilanguage-experience/:id',
    CREATE: '/multilanguage-experience'
  },
  TAGS: {
    LIST: '/tags'
  },
  QR_CODES: {
    LIST: '/qr-codes'
  },
  STICKERS: {
    LIST: '/stickers',
    EDIT: '/sticker/:id',
    CREATE: '/sticker'
  },
  HTML_TEMPLATES: {
    LIST: '/html-templates',
    EDIT: '/html-template/:id',
    CREATE: '/html-template'
  },
  MEDIA_FILES: {
    LIST: '/media'
  },
  AR_MARKERS: {
    LIST: '/ar-markers'
  },
  USERS: {
    LIST: '/users',
    EDIT: '/user/:id',
    CREATE: '/user',
    PROFILEEDIT: '/profileuser/:id'
  },
  CONFIGURATION: {
    EDIT: '/configuration'
  },
  READERS: {
    LIST: '/readers',
    EDIT: '/reader/:id',
    CREATE: '/reader'
  },
  READER_REQUESTS: {
    LIST: '/requests',
    EDIT: '/request/:id'
  },
  TOBACCO_PRODUCTS: {
    LIST: '/products',
    EDIT: '/product/:id',
    CREATE: '/product'
  },
  ANALYTICS_REPORTS: {
    LIST: '/analytics-reports',
    EDIT: '/analytics-report/:id',
    CREATE: '/analytics-report'
  },
  OPERATORS: {
    LIST: '/operators',
    EDIT: '/operator/:id',
    CREATE: '/operator'
  },
  PRODUCTION_DASHBOARD: '/dashboard-production',
  ERROR: '/error',
  HEALTH: '/health'
};

export const ACADEMY_PATH = {
  '/scans': '/documentation/data-analytics/',
  '/experience': '/documentation/experiences/',
  '/multilanguage-experience': '/documentation/multi-languages/',
  '/tags': '/documentation/tags/',
  '/qr-codes': '/documentation/qr-codes/',
  '/sticker': '/documentation/stickers/',
  '/html-template': '/documentation/html-templates/',
  '/media': '/documentation/media-library/',
  '/ar-markers': '/documentation/ar-markers/',
  '/user': '/documentation/users/',
  '/profileuser': '/documentation/users/#user-profile',
  '/configuration': '/documentation/configuration/',
  '/reader': '/documentation/readers/',
  '/analytics-report': '/documentation/analytics-reports/',
  '/request': '/documentation/production/#requests',
  '/product': '/documentation/production/#products',
  '/dashboard-production': '/documentation/production/#production-dashboard',
  '/operator': '/documentation/production/#operators'
};
